import React, { type ReactElement } from 'react';
import { Box } from '@saviynt/design-system';
import cx from 'classnames';

import './CommonAsterisk.css';

export interface CommonAsteriskProps {
  isRequired: boolean | undefined;
  isCritical?: boolean;
  shouldRequiredAsterisk?: boolean;
}

function CommonAsterisk({
  isRequired,
  isCritical = false,
  shouldRequiredAsterisk = false,
}: CommonAsteriskProps): ReactElement | null {
  if (!isRequired || !shouldRequiredAsterisk) {
    return null;
  }

  return (
    <Box
      className={cx(
        'FF-CommonAsterisk',
        `FF-CommonAsterisk--${isCritical ? 'isCritical' : 'isWarning'}`
      )}>
      {/* eslint-disable formatjs/no-literal-string-in-jsx -- Visual indicator */}
      *{/* eslint-enable formatjs/no-literal-string-in-jsx */}
    </Box>
  );
}

export default CommonAsterisk;
